// Header.js
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";

export default function Header() {
  return (
    <Navbar bg="light" expand="lg" className="custom-navbar mt-3 mb-5 py-0">
      <Container className="d-flex flex-column align-items-center text-center p-0">
        {/* ===== Mobile Layout ===== */}
        <div className="d-flex w-100 justify-content-between d-lg-none">
          {/* Logo on left */}
          <Navbar.Brand as={NavLink} to="/" className="m-0">
            <img
              src="/scopewithin.png"
              alt="ScopeWithin Logo"
              className="logo-img"
              style={{ maxHeight: "45px" }}
            />
          </Navbar.Brand>
        </div>

        {/* ===== Desktop Layout ===== */}
        <div className="d-none d-lg-flex flex-column">
          <Navbar.Brand as={NavLink} to="/" className="mb-3">
            <img
              src="/scopewithin.png"
              alt="ScopeWithin Logo"
              className="logo-img mb-2"
              style={{ maxHeight: "70px" }}
            />
          </Navbar.Brand>
        </div>
      </Container>
    </Navbar>
  );
}
